import { useState } from 'react';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import { post } from '../../Auths/AuthToken';
import CredentialingPopup from './CredentialingPopup';
import setUiMessage from '../../../Utilities/Tostify';
import ViewCredentialingPopup from './ViewCredentialingPopup';
import { useSelector } from 'react-redux';
import CredentialingAddPlanPopup from './CredentialingAddPlanPopup';

function Credentialing({ item, ptoggleGrid, reload, payerPlanList = {} }) {
  const { user } = useSelector((state) => state.auth);
  const [toggleGrid, setToggleGrid] = useState(ptoggleGrid);
  const [copyPayerMatrix, setCopyPayerMatrix] = useState({
    status: false,
    data: null,
  });
  const [deleteMatrix, setDeleteMatrix] = useState({
    status: false,
    data: null,
  });
  const [editMatrix, setEditMatrix] = useState({
    status: false,
    data: null,
  });
  const [viewMatrixPopup, setViewMatrixPopup] = useState({
    status: false,
    data: null,
  });
  const [addEditPlanPopup, setAddEditPlanPopup] = useState({
    status: false,
    credential_id: '',
    payerId: '',
    planId: '',
  });
  const [deleteAddedPlan, setDeleteAddedPlan] = useState({
    status: false,
    id: null,
  });
  const [copyAddedPlan, setCopyAddedPlan] = useState({
    status: false,
    data: null,
  });

  const deletePayerMatrixHandler = async (id) => {
    try {
      const response = await post(
        'api/reports/managePayerMatrix/deletePayerMatrix',
        {
          loginUserId: user?.id,
          payerMatrixId: id,
        }
      );
      if (response.status === 200) {
        reload();
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };
  const copyPayerMatrixHandler = (id, payerId) => {
    setCopyPayerMatrix({
      status: true,
      data: { id, payerId },
    });
  };

  const copyPayerMatrixConfirmHandler = async (id, payerId) => {
    try {
      const response = await post(
        'api/reports/managePayerMatrix/copyPayerMatrix',
        { loginUserId: user?.id, payerId: payerId }
      );
      if (response.status === 200) {
        reload();
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };

  const deleteAddedPlanHandler = async (id) => {
    try {
      const response = await post(
        'api/reports/managePayerMatrix/deletePayerPlan',
        {
          payerPlanId: id,
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        reload();
        setUiMessage('suc', 'Record deleted successfully.');
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };

  const copyAddedPlanHandler = (planId, payerId) => {
    setCopyAddedPlan({
      status: true,
      data: { planId, payerId },
    });
  };

  const copyAddedPlanConfirmHandler = async (planId, payerId) => {
    try {
      const response = await post(
        'api/reports/managePayerMatrix/copyPayerPlan',
        { loginUserId: user?.id, payerId: payerId, planId: planId }
      );
      if (response.status === 200) {
        reload();
        setUiMessage('suc', 'Record added successfully.');
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };

  return (
    <div
      className={`${
        toggleGrid
          ? 'chld-doc-active-rw docMaingrid-Pat-sb-bdy grid-sec'
          : 'docMaingrid-Pat-sb-bdy grid-sec'
      }`}
    >
      <div
        className="docMaingrid-Pat-bdy-rw flex-sec"
        style={{ alignItems: 'center', gap: '10px' }}
      >
        <span className="colm3">
          <span
            className="collapse-icon"
            onClick={() => setToggleGrid(!toggleGrid)}
          >
            {toggleGrid ? '-' : '+'}
          </span>
        </span>
        <span className="">
          {item?.showproName} {`(${item?.child?.length})`}
        </span>
      </div>
      <div className={toggleGrid ? 'child-bdy-sec' : 'child-bdy-sec hide'}>
        <div className="grid-sec">
          {item?.child &&
            item?.child?.map((item, i) => (
              <div
                key={i}
                className={`docMaingrid-Pat-bdy-rw flex-sec ${
                  i % 2 === 0 ? 'alt-rw' : ''
                }`}
              >
                <span className="pacolm4">{item?.insurance_company_name}</span>
                <span className="pacolm5">
                  {item?.application_status_value}
                </span>
                <span className="pacolm5">{item?.effective}</span>
                <span className="pacolm5">{item?.edi_status_value}</span>
                <span className="pacolm5">{item?.era_status_value}</span>
                <span className="pacolm5">{item?.eft_status_value}</span>
                <span className="pacolm5">
                  {item?.payer_portal_status_value}
                </span>
                <span className="pacolm4">
                  <span
                    title="View"
                    style={{
                      display: 'flex',
                      gap: '10px',
                    }}
                  >
                    <Link
                      className="matrix-actn-item"
                      href="#"
                      onClick={() =>
                        setViewMatrixPopup({ status: true, data: item?.id })
                      }
                    >
                      View
                    </Link>
                    <span className="matrx-actn-sep">|</span>
                    <Link
                      className="matrix-actn-item"
                      href="#"
                      onClick={() =>
                        setEditMatrix({
                          status: true,
                          data: { id: item?.id },
                        })
                      }
                    >
                      Edit
                    </Link>
                    <span className="matrx-actn-sep">|</span>
                    <Link
                      className="matrix-actn-item"
                      href="#"
                      onClick={() =>
                        setDeleteMatrix({
                          status: true,
                          data: item?.id,
                        })
                      }
                    >
                      Delele
                    </Link>
                    <span className="matrx-actn-sep">|</span>
                    <Link
                      className="matrix-actn-item"
                      href="#"
                      onClick={() => {
                        setAddEditPlanPopup({
                          status: true,
                          credential_id: item?.id,
                          payerId: item?.payer_id,
                          planId: '',
                        });
                      }}
                    >
                      Add Plan
                    </Link>
                    {item?.type === '0' && (
                      <>
                        <span className="matrx-actn-sep">|</span>
                        <Link
                          className="matrix-actn-item"
                          href="#"
                          onClick={() =>
                            copyPayerMatrixHandler(item?.id, item?.payer_id)
                          }
                        >
                          Copy
                        </Link>
                      </>
                    )}
                  </span>
                </span>
                <div>
                  {payerPlanList?.[item?.id] &&
                    payerPlanList?.[item?.id].length > 0 && (
                      <>
                        <div>
                          <div className="biilGridHeader matrix-grid ">
                            <div className="paycol left gwb gw6">
                              <span>&nbsp;</span>
                            </div>
                            <div className="paycol left gwb gw19">
                              <span>Plan</span>
                            </div>
                            <div className="paycol left gwb gw10">
                              <span>Status</span>
                            </div>
                            <div className="paycol left gwb gw9">
                              <span>Effective</span>
                            </div>
                            <div className="paycol left gwb gw36">
                              <span>Note</span>
                            </div>
                            <div className="paycol left gwb gw20">
                              <span>Action</span>
                            </div>
                          </div>
                          {payerPlanList?.[item?.id].map((plan, i) => (
                            <div
                              key={plan?.id}
                              id="biilGridSubRow1"
                              className="biilGridRow matrix-grid pms-billGridOddRowColor"
                            >
                              <div id="1" className="biilPaymentGridRow ">
                                <div className="paycol left gwb gw6">
                                  <span>&nbsp;</span>
                                </div>
                                <div className="paycol left gwb gw19">
                                  <span title="demo plan">
                                    {plan?.plan_name}
                                  </span>
                                </div>
                                <div className="paycol left gwb gw10">
                                  <span title="Approved">
                                    {plan?.plan_status}
                                  </span>
                                </div>
                                <div className="paycol left gwb gw9">
                                  <span title="">
                                    {plan?.plan_effective_date}
                                  </span>
                                </div>
                                <div className="paycol left gwb gw36">
                                  <span title="It's a demo plan">
                                    {plan?.plan_note}
                                  </span>
                                </div>
                                <div className="paycol left gwb gw20">
                                  <div>
                                    <Link
                                      className="matrix-actn-item"
                                      href="#"
                                      onClick={() => {
                                        setAddEditPlanPopup({
                                          status: true,
                                          credential_id: plan?.credential_id,
                                          payerId: plan?.payer_id,
                                          planId: plan?.id,
                                        });
                                      }}
                                    >
                                      Change
                                    </Link>
                                    <span className="left matrx-actn-sep">
                                      |
                                    </span>
                                    <Link
                                      className="left"
                                      href="#"
                                      onClick={() => {
                                        setDeleteAddedPlan({
                                          status: true,
                                          id: plan?.id,
                                        });
                                      }}
                                    >
                                      Delele
                                    </Link>
                                    {item?.type === '0' && (
                                      <>
                                        <span className="left matrx-actn-sep">
                                          |
                                        </span>
                                        <Link
                                          className="left"
                                          href="#"
                                          onClick={() =>
                                            copyAddedPlanHandler(
                                              plan?.id,
                                              plan?.payer_id
                                            )
                                          }
                                        >
                                          Copy
                                        </Link>
                                      </>
                                    )}
                                    <span className="left matrx-actn-sep">
                                      |
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                </div>
              </div>
            ))}
        </div>
      </div>
      {copyPayerMatrix.status && (
        <ConfirmDialog
          title="Record"
          bodytext="Are you want to record the payer to all the provider ?"
          closeDialog={() => setCopyPayerMatrix({ status: false, data: null })}
          successDialog={() =>
            copyPayerMatrixConfirmHandler(
              copyPayerMatrix.data.id,
              copyPayerMatrix.data.payerId
            )
          }
        />
      )}
      {deleteMatrix.status && (
        <ConfirmDialog
          title="Record"
          bodytext="Are you want to delete the payer matrix ?"
          closeDialog={() => setDeleteMatrix({ status: false, data: null })}
          successDialog={() => deletePayerMatrixHandler(deleteMatrix.data)}
        />
      )}
      {editMatrix.status && (
        <CredentialingPopup
          close={() => setEditMatrix({ status: false, data: null })}
          id={editMatrix.data.id}
          reload={reload}
        />
      )}
      {viewMatrixPopup.status && (
        <ViewCredentialingPopup
          close={() => setViewMatrixPopup({ status: false, data: null })}
          id={viewMatrixPopup.data}
          editPopup={(id) =>
            setEditMatrix({
              status: true,
              data: { id: id },
            })
          }
        />
      )}
      {addEditPlanPopup?.status && (
        <CredentialingAddPlanPopup
          close={() =>
            setAddEditPlanPopup({
              status: false,
              payerId: '',
              planId: '',
            })
          }
          credential_id={addEditPlanPopup?.credential_id}
          payerId={addEditPlanPopup?.payerId}
          planId={addEditPlanPopup?.planId}
          reload={reload}
        />
      )}
      {deleteAddedPlan.status && (
        <ConfirmDialog
          title="Record"
          bodytext="Are you sure you want to delete this record?"
          closeDialog={() => setDeleteAddedPlan({ status: false, id: null })}
          successDialog={() => deleteAddedPlanHandler(deleteAddedPlan.id)}
        />
      )}
      {copyAddedPlan.status && (
        <ConfirmDialog
          title="Record"
          bodytext="Do you want to copy the plan to all the providers with this Payor?"
          closeDialog={() => setCopyAddedPlan({ status: false, data: null })}
          successDialog={() =>
            copyAddedPlanConfirmHandler(
              copyAddedPlan.data.planId,
              copyAddedPlan.data.payerId
            )
          }
        />
      )}
    </div>
  );
}

export default Credentialing;
